<template>
    <div class="pop-up--form card card--lg">
        <recurring-new v-if="step === 'NEW'"></recurring-new>
        <recurring-basket v-if="step === 'BASKET'"></recurring-basket>
        <recurring-summary v-if="step === 'SUMMARY'"></recurring-summary>
        <order-payment v-if="step === 'PAYMENT'"></order-payment>
        <order-congrats v-if="step === 'CONGRATS'"></order-congrats>
    </div>
</template>

<script>
export default {
    props: ['products', 'halfDays'],

    data() {
        return {
            step: 'NEW',
            date: null,
            method: null,
            every_other_week: "0",
            cart: {},
            products: this.products,
            loading: 0,
            extraProductsByDay: {},
        }
    },

    beforeMount() {
        // Set cart if order exist
        if (this.$root.orders.recurring) {
            let order = { ...this.$root.orders.recurring };
            this.date = moment(order.start_date).format('DD/MM/YYYY');
            this.method = order.method;
            this.every_other_week = order.every_other_week;

            order.extra_products.forEach((extraProduct) => {
              extraProduct = { ...extraProduct };

              if (!this.extraProductsByDay[extraProduct.date_delivery]) {
                this.extraProductsByDay[extraProduct.date_delivery] = [];
              }

              this.extraProductsByDay[extraProduct.date_delivery].push(extraProduct);
            });

            order.recurring_order_time_slots.map((slot) => {
                let day = {
                    products: {},
                    time_slot_id: slot.time_slot.id
                };

                this.products.map((product) => {
                    const cartItem = slot.products.find(e => e.id === product.id)

                    day.products[product.id] = { ...product };
                    day.products[product.id].qty = cartItem ? cartItem.qty : 0;

                    product.stock += day.products[product.id].qty;
                    return product;
                })

                this.$set(this.cart, slot.time_slot.day, day);
            });
        }

        this.halfDays.forEach((halfDay, index) => {
            const day = halfDay.code.split('_')[0];
            this.halfDays[index].day = day;
            if (day === 'SUNDAY') this.halfDays[index].dayNumber = 0;
            if (day === 'MONDAY') this.halfDays[index].dayNumber = 1;
            if (day === 'TUESDAY') this.halfDays[index].dayNumber = 2;
            if (day === 'WEDNESDAY') this.halfDays[index].dayNumber = 3;
            if (day === 'THURSDAY') this.halfDays[index].dayNumber = 4;
            if (day === 'FRIDAY') this.halfDays[index].dayNumber = 5;
            if (day === 'SATURDAY') this.halfDays[index].dayNumber = 6;
        });
    },

    mounted() {
    },

    methods: {
        sendOrder(card = null) {
            if (!this.loading) {
                this.loading = true;

                let formattedCart = Object.keys(this.cart).map((day) => ({
                    'day': day,
                    'time_slot_id': this.cart[day].time_slot_id,
                    'products': Object.keys(this.cart[day].products)
                        .filter((product) => {
                            return this.cart[day].products[product].qty > 0;
                        })
                        .map((product) => {
                            return {
                                'product_id': this.cart[day].products[product].id,
                                'qty': this.cart[day].products[product].qty
                            }
                        })
                }));

                // Order
                axios.post("/api/order/recurring", {
                    customer_id: this.$root.user.id,
                    start_date: this.date,
                    method: this.method,
                    every_other_week: this.every_other_week === "1" ? 1 : 0,
                    cart: formattedCart,
                    card: card ? JSON.stringify(card) : null,
                }).then(res => {
                    this.loading = false;

                    if (res.data.success === false) {
                        alert('An error has occurred.');
                    } else {
                        if (typeof gtag_report_conversion === "function") {
                            gtag_report_conversion();
                        }
                        if (typeof fbq === "function") {
                            fbq('track', 'Purchase');
                        }
                        // Show congrats popup
                        this.step = 'CONGRATS';

                        // Update data
                        this.$root.orders.recurring = res.data.datas.recurring;
                        this.$root.orders.upcoming = res.data.datas.upcoming;
                        this.$root.next_delivery = res.data.datas.next_delivery;
                        this.$root.next_recurring_orders = res.data.datas.next_recurring_orders;
                    }
                }).catch(error => console.log(error));
            }

            return false;
        }
    }
}
</script>
